import { useCallback, useEffect, useState } from "react";
import AdminManagementLayout from "../components/admin/AdminManagementLayout";
import NewsManager from "../components/admin/NewsManager";
import PageContentManager from "../components/admin/PageContentManager";
import { API } from "../data/siteData";
import useAdminAccess from "../hooks/useAdminAccess";

export default function AdminContentPage() {
  const accessState = useAdminAccess();
  const [news, setNews] = useState([]);
  const [pages, setPages] = useState([]);
  const [state, setState] = useState("loading");

  const loadContent = useCallback(async () => {
    try {
      const [newsResponse, pagesResponse] = await Promise.all([
        fetch(`${API}/admin/news`, { credentials: "include" }),
        fetch(`${API}/admin/content-pages`, { credentials: "include" }),
      ]);
      if (!newsResponse.ok || !pagesResponse.ok) throw new Error();
      setNews(await newsResponse.json());
      setPages(await pagesResponse.json());
      setState("ready");
    } catch {
      setState("error");
    }
  }, []);

  useEffect(() => {
    if (accessState === "ready") loadContent();
  }, [accessState, loadContent]);

  if (accessState === "loading" || state === "loading") return <main className="portal-state" data-testid="admin-content-loading">Loading content controls…</main>;
  if (state === "error") return <main className="portal-state" data-testid="admin-content-error">Content controls are temporarily unavailable.</main>;

  return <AdminManagementLayout active="content" eyebrow="Control Room publishing" title="CONTENT STUDIO"><NewsManager articles={news} onRefresh={loadContent} /><PageContentManager pages={pages} onRefresh={loadContent} /></AdminManagementLayout>;
}